import React, { useState, useRef, useMemo } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import JoditEditor from 'jodit-react';
import {
  Button,
  DatePicker,
  Form,
  Input,
} from 'antd';
import Swal from 'sweetalert2';
import { useAdminClient } from "hooks/useAdminClient";

const CreateArticle = ({ placeholder }) => {
  const editor = useRef(null);
  const client = useAdminClient();
	const [content, setContent] = useState('');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [form] = Form.useForm();
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

	const config = useMemo(() => ({
			readonly: false, // all options from https://xdsoft.net/jodit/docs/,
			placeholder: placeholder || 'Start typings...'
		}),
		[placeholder]
	);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
  };

  const handleSubmit = async (e) => {
    try {
      if (!file) return alert("Please select a file.");

      const formData = new FormData();
      const {
        // InputBannerImg,
        InputPostCreator,
        InputPostTitle,
        InputPostCardTitle,
        InputPostCardTextDetail,
        InputPostTextDetail,
        PostDate
      } = e;
      
      formData.append("img", file);
      formData.append("title", InputPostTitle);
      formData.append("text", InputPostTextDetail);
      formData.append("card_title", InputPostCardTitle);
      formData.append("card_text", InputPostCardTextDetail);
      formData.append("date", PostDate);
      formData.append("creator", InputPostCreator);
      
      await client.post("/be/api/v1/articles/create", formData, { headers: { "Content-Type": "multipart/form-data", 
        "Authorization": `Bearer ${localStorage.getItem("authToken")}`, // Add Bearer prefix
      }});
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Create article success",
        showConfirmButton: false,
        timer: 1500
      });
      form.resetFields();
      setPreview('')
    } catch (error) {
      console.log(error);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Add articles error",
        showConfirmButton: false,
        timer: 1500
      });
    }
  }

	return (
    <Container>
      <Row style={{height: "100vh", overflow: "scroll"}}>
        <Col>
          <h1>Add New Article</h1>
          <Form
            {...formItemLayout}
            form={form}
            onFinish={handleSubmit}
          >
            <Form.Item
              label="Input Banner Image"
              name="InputBannerImg"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input type="file" accept="image/*" onChange={handleFileChange}/>
              {preview && <img src={preview} alt="Preview" width="200" />}
            </Form.Item>
            <Form.Item
              label="Input Post Creator"
              name="InputPostCreator"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Input Post Title"
              name="InputPostTitle"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Input Post Card Title"
              name="InputPostCardTitle"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Input Post Card Text Detail"
              name="InputPostCardTextDetail"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input
                style={{
                  width: '100%',
                }}
              />
            </Form.Item>

            <Form.Item
              label="Input Post Text Detail"
              name="InputPostTextDetail"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <JoditEditor
                  ref={editor}
                  value={content}
                  config={config}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                  onChange={newContent => {}}
                />
            </Form.Item>

            <Form.Item
              label="Post Date"
              name="PostDate"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 6,
                span: 16,
              }}
            >
              <Button
                style={{maxWidth: "100px"}}
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Container>
	);
};

export default CreateArticle